import { useEffect, useState } from "react";
import { API } from "@/lib/api";

export function AuthImage({ path, alt, className }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!path) return;
    let revoked = null;
    const token = localStorage.getItem("token");
    fetch(`${API}/files/${path}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then((r) => (r.ok ? r.blob() : Promise.reject()))
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        revoked = url;
        setSrc(url);
      })
      .catch(() => setSrc(null));
    return () => {
      if (revoked) URL.revokeObjectURL(revoked);
    };
  }, [path]);

  if (!path) return null;
  if (!src)
    return <div className={`${className} animate-pulse bg-[#EFE7D8]`} />;
  return <img src={src} alt={alt} className={className} />;
}
